// ? 全局默认配置项
export const CDN_URL = "https://static.zhihaoscm.cn/";

// 首页地址（默认）
export const HOME_URL: string = "/map";

// 全匹配路由名(默认)
export const MATCH_NAME: string = "matchAll";

// 默认主题颜色
export const DEFAULT_PRIMARY: string = "#FFBE17";

// 路由白名单地址（本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = ["/500"];

// 高德地图 js api key
export const AMAP_MAP_JS_KEY: string = "fa6124a9dc6b90b47e10e0606c340538";

// 高德地图 web云服务 key
export const AMAP_MAP_WEB_KEY: string = "2c93a1b3e2cb4e43e173c50caa49792d";

// 日期时间选择器格式化
export const DATETIME_PICKER_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_PICKER_FORMAT = "YYYY-MM-DD";
export const TIME_PICKER_FORMAT = "HH:mm:ss";

// 日志时间戳格式化
export const LOG_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

// 新增、修改弹框宽度
export const DEFAULT_DIALOG_WIDTH = "842px";
export const W900_DIALOG_WIDTH = "900px";
export const VW75_DIALOG_WIDTH = "75%";

// 上传导入Excel文件格式
export const UploadExcelFileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

// 指数管理批量上传模板
export const ProductTypeIndexFileName =
    "%E6%8C%87%E6%95%B0%E7%AE%A1%E7%90%86%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx";

// 设备管理批量上传模板
export const DeviceTypeIndexFileName = CDN_URL + "template/%E8%AE%BE%E5%A4%87%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";
// 运价指数批量上传模板
export const FreightIndexFileName =
    CDN_URL + "template/%E8%BF%90%E4%BB%B7%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E7%89%88.xlsx";

// 选项卡最大数量
export const MAX_TAG_NUMBER = 10;

// 数据缺省值
export const DEFAULT_VALUE = "--";

// 权重最大值
export const MAX_WEIGHT = 10000;
